import { render } from "./GameOne.vue?vue&type=template&id=b6340d80"
import script from "./GameOne.vue?vue&type=script&lang=js"
export * from "./GameOne.vue?vue&type=script&lang=js"

import "./GameOne.vue?vue&type=style&index=0&id=b6340d80&lang=css"

import exportComponent from "C:\\src\\Inmersys\\tres-prima\\mundo-zac-webapp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__